import { Box, Text } from "@radix-ui/themes";
import { useI18n } from "@/i18n";
import { formatDateDisplay } from "@/lib/dates";
import { formatValue, unitLabelKey } from "@/lib/format";
import type { ObservationPoint, Unit } from "@/types";
import { SplitFlapValue } from "./SplitFlapValue";

interface CurrentValueReadoutProps {
  status: "loading" | "ready" | "empty" | "error";
  latestPoint: ObservationPoint | null;
  unit: Unit | null;
  unitVars?: Record<string, string>;
}

export function CurrentValueReadout({ status, latestPoint, unit, unitVars }: CurrentValueReadoutProps) {
  const { t, locale } = useI18n();

  const displayText =
    status === "ready" && latestPoint && unit ? formatValue(latestPoint.value, unit) : "– – – –";

  return (
    <Box className="rk-readout" aria-live="polite" aria-busy={status === "loading"}>
      <Text as="div" size="1" color="gray" className="rk-readout-label">
        {t("readout.latest")}
      </Text>
      <SplitFlapValue text={displayText} ariaLabel={displayText} />
      <Text as="div" size="1" color="gray" className="rk-readout-sub">
        {status === "ready" && latestPoint
          ? t("readout.asOf", { date: formatDateDisplay(latestPoint.date, locale) })
          : status === "loading"
            ? " "
            : t("readout.noData")}
      </Text>
      {unit && (
        <Text as="div" size="1" color="gray" className="rk-readout-unit">
          {t(unitLabelKey(unit), unitVars)}
        </Text>
      )}
    </Box>
  );
}
